import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SplatTransformIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M9.77 3.60002H11.38V6.00002C11.38 6.35002 11.66 6.62002 12 6.62002C12.34 6.62002 12.62 6.34002 12.62 6.00002V3.60002H14.23C14.53 3.60002 14.7 3.24002 14.51 3.01002L12.46 0.55002C12.22 0.26002 11.78 0.26002 11.54 0.55002L9.49 3.01002C9.29 3.24002 9.46 3.60002 9.77 3.60002Z"
        fill={color}
      />
      <path
        d="M14.23 20.4H12.62V18C12.62 17.66 12.34 17.38 12 17.38C11.66 17.38 11.38 17.66 11.38 18V20.4H9.76999C9.46999 20.4 9.29999 20.76 9.48999 20.99L11.54 23.45C11.78 23.74 12.22 23.74 12.46 23.45L14.51 20.99C14.71 20.76 14.54 20.4 14.23 20.4Z"
        fill={color}
      />
      <path
        d="M23.45 11.54L20.99 9.49C20.76 9.29 20.4 9.46 20.4 9.77V11.38H18C17.66 11.38 17.38 11.66 17.38 12C17.38 12.34 17.66 12.62 18 12.62H20.4V14.23C20.4 14.53 20.76 14.7 20.99 14.51L23.45 12.46C23.74 12.22 23.74 11.78 23.45 11.54Z"
        fill={color}
      />
      <path
        d="M6.00002 11.38H3.60002V9.76999C3.60002 9.46999 3.24002 9.29999 3.01002 9.48999L0.55002 11.54C0.26002 11.78 0.26002 12.22 0.55002 12.46L3.01002 14.51C3.24002 14.71 3.60002 14.54 3.60002 14.23V12.62H6.00002C6.35002 12.62 6.62002 12.34 6.62002 12C6.62002 11.66 6.34002 11.38 6.00002 11.38Z"
        fill={color}
      />
      <path
        d="M9.63 8H8.62C8.27758 8 8 8.27758 8 8.62V9.63C8 9.97242 8.27758 10.25 8.62 10.25H9.63C9.97242 10.25 10.25 9.97242 10.25 9.63V8.62C10.25 8.27758 9.97242 8 9.63 8Z"
        fill={color}
      />
      <path
        d="M9.63 13.75H8.62C8.27758 13.75 8 14.0276 8 14.37V15.38C8 15.7224 8.27758 16 8.62 16H9.63C9.97242 16 10.25 15.7224 10.25 15.38V14.37C10.25 14.0276 9.97242 13.75 9.63 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 13.75H14.37C14.0276 13.75 13.75 14.0276 13.75 14.37V15.38C13.75 15.7224 14.0276 16 14.37 16H15.38C15.7224 16 16 15.7224 16 15.38V14.37C16 14.0276 15.7224 13.75 15.38 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 8H14.37C14.0276 8 13.75 8.27758 13.75 8.62V9.63C13.75 9.97242 14.0276 10.25 14.37 10.25H15.38C15.7224 10.25 16 9.97242 16 9.63V8.62C16 8.27758 15.7224 8 15.38 8Z"
        fill={color}
      />
      <path
        d="M12.51 10.88H11.5C11.1576 10.88 10.88 11.1576 10.88 11.5V12.51C10.88 12.8524 11.1576 13.13 11.5 13.13H12.51C12.8524 13.13 13.13 12.8524 13.13 12.51V11.5C13.13 11.1576 12.8524 10.88 12.51 10.88Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SplatTransformIcon.displayName = 'SplatTransformIcon';
